import { HttpClient } from "@angular/common/http";
import {TranslateJsonHttpLoader} from '../translate-json-http-loader';

export function localizationHttpLoaderFactory(httpClient: HttpClient): TranslateJsonHttpLoader {
    return new TranslateJsonHttpLoader(httpClient, '/assets/i18n');
}
